import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, isRef as _isRef, vModelText as _vModelText, withKeys as _withKeys, createElementVNode as _createElementVNode, withDirectives as _withDirectives, resolveComponent as _resolveComponent, createVNode as _createVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "hidden md:flex items-center" }
const _hoisted_2 = ["placeholder", "title"]
const _hoisted_3 = { class: "md:hidden h-full w-full flex justify-end items-end absolute pr-2 bottom-2" }
const _hoisted_4 = { class: "flex gap-4 w-[35px] rounded-md focus-within:w-full focus-within:bg-hub-background-4 focus-within:dark:bg-hub-background-3 transition-all duration-200 justify-end relative items-center max-w-full overflow-hidden" }
const _hoisted_5 = ["placeholder", "title"]
const _hoisted_6 = { class: "dark:text-gray-lighter px-1 rounded-full bg-hub-background-4 dark:bg-gray-darker flex justify-center items-center aspect-[1]" }

import { useFormInputEvents, usedEvents } from '@/composables/useFormInputEvents';

	
export default /*#__PURE__*/_defineComponent({
  __name: 'SearchInput',
  emits: usedEvents,
  setup(__props, { emit: __emit }) {

	const emit = __emit;
	const { value, changed, submit, cancel } = useFormInputEvents(emit);

return (_ctx: any,_cache: any) => {
  const _component_Icon = _resolveComponent("Icon")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _withDirectives(_createElementVNode("input", {
        class: "w-full md:pr-8 py-1 border-none rounded-md bg-gray-lighter placeholder:text-black dark:bg-gray-darker dark:text-white dark:placeholder:text-gray-light focus:border-black focus:outline-0 focus:outline-offset-0 focus:ring-0",
        type: "text",
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (_isRef(value) ? (value).value = $event : null)),
        placeholder: _ctx.$t('others.search'),
        title: _ctx.$t('others.search'),
        onKeydown: [
          _cache[1] || (_cache[1] = ($event: any) => (_unref(changed)())),
          _cache[2] || (_cache[2] = _withKeys(($event: any) => (_unref(submit)()), ["enter"])),
          _cache[3] || (_cache[3] = _withKeys(($event: any) => (_unref(cancel)()), ["esc"]))
        ]
      }, null, 40, _hoisted_2), [
        [_vModelText, _unref(value)]
      ]),
      _createVNode(_component_Icon, {
        class: "-ml-6 search-icon dark:text-gray-light -scale-100 -rotate-90",
        type: "search",
        size: "sm",
        onClick: _cache[4] || (_cache[4] = ($event: any) => (_unref(submit)()))
      })
    ]),
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", _hoisted_4, [
        _withDirectives(_createElementVNode("input", {
          class: "h-10 flex-1 w-full placeholder:text-black dark:text-white dark:placeholder:text-gray-light bg-transparent border-none focus:outline-0 focus:outline-offset-0 focus:ring-0",
          type: "text",
          "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => (_isRef(value) ? (value).value = $event : null)),
          placeholder: _ctx.$t('others.search'),
          title: _ctx.$t('others.search'),
          onKeydown: [
            _cache[6] || (_cache[6] = ($event: any) => (_unref(changed)())),
            _cache[7] || (_cache[7] = _withKeys(($event: any) => (_unref(submit)()), ["enter"])),
            _cache[8] || (_cache[8] = _withKeys(($event: any) => (_unref(cancel)()), ["esc"]))
          ]
        }, null, 40, _hoisted_5), [
          [_vModelText, _unref(value)]
        ]),
        _createElementVNode("button", _hoisted_6, [
          _createVNode(_component_Icon, {
            class: "search-icon -scale-100 -rotate-90 px-1",
            type: "search",
            size: "md"
          })
        ])
      ])
    ])
  ], 64))
}
}

})